

// import React, { useState } from 'react';
// import './GallerySection.css';
// import { motion } from 'framer-motion';

// // 🔥 IMPORT YOUR LOCAL IMAGES
// import weightFloor from '../assests/gym1.jpeg';
// import cardio from '../assests/gym2.jpeg';
// import freeWeights from '../assests/gym3.jpeg';
// import functional from '../assests/gym4.jpeg';
// // import training from '../assets/training.jpg';

// const images = [
//   { src: weightFloor, label: 'Weight Floor', size: 'large' },
//   { src: cardio, label: 'Cardio Zone', size: 'small' },
//   { src: freeWeights, label: 'Free Weights', size: 'small' },
//   { src: functional, label: 'Functional Zone', size: 'small' },
// //   { src: training, label: 'Training Area', size: 'medium' },
// ];

// export default function GallerySection() {
//   const [activeImg, setActiveImg] = useState(null);

//   // 🔥 TEXT animation
//   const fadeUp = {
//     hidden: { opacity: 0, y: 30 },
//     show: { opacity: 1, y: 0 }
//   };

//   // 🔥 GRID stagger
//   const container = {
//     hidden: {},
//     show: {
//       transition: {
//         staggerChildren: 0.15,
//       },
//     },
//   };

//   // 🔥 ITEM animation
//   const item = {
//     hidden: { opacity: 0, scale: 0.9 },
//     show: { opacity: 1, scale: 1 },
//   };

//   return (
//     <section id="gallery" className="gallery-section">
//       <div className="container">

//         {/* 🔥 HEADER */}
//         <motion.p
//           className="section-label"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//         >
//           Inside the Arena
//         </motion.p>

//         <motion.h2
//           className="section-title"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           transition={{ delay: 0.1 }}
//           viewport={{ once: false, amount: 0.2 }}
//         >
//           The <span>Facility</span>
//         </motion.h2>

//         <motion.div
//           className="divider"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           transition={{ delay: 0.2 }}
//           viewport={{ once: false, amount: 0.2 }}
//         />

//         {/* 🔥 GRID */}
//         <motion.div
//           className="gallery-grid"
//           variants={container}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//         >
//           {images.map((img, i) => (
//             <motion.div
//               key={i}
//               className={`gallery-item gallery-item--${img.size}`}
//               variants={item}
//               whileHover={{ scale: 1.05 }}
//               onClick={() => setActiveImg(img.src)}
//             >
//               <img src={img.src} alt={img.label} />

//               <div className="gallery-overlay">
//                 <span>{img.label}</span>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>

//       </div>

//       {/* 🔥 LIGHTBOX (CLICK VIEW) */}
//       {activeImg && (
//         <div className="lightbox" onClick={() => setActiveImg(null)}>
//           <img src={activeImg} alt="Preview" />
//         </div>
//       )}
//     </section>
//   );
// }



import React from 'react';
import './GallerySection.css';
import { motion } from 'framer-motion';

// ✅ LOCAL IMAGES
import gym1 from '../assests/gym1.jpeg';
import gym2 from '../assests/gym2.jpeg';
import gym3 from '../assests/gym3.jpeg';
import gym4 from '../assests/gym4.jpeg';

const images = [
  { src: gym1, label: 'Weight Floor' },
  { src: gym2, label: 'Cardio Zone' },
  { src: gym3, label: 'Free Weights' },
  { src: gym4, label: 'Functional Zone' },
];

// 🔥 DUPLICATE for seamless loop
const loopImages = [...images, ...images];

export default function GallerySection() {
  return (
    <section id="gallery" className="gallery-section">
      <div className="container">

        <p className="section-label">Inside the Arena</p>

        <h2 className="section-title">
          The <span>Facility</span>
        </h2>

        <div className="divider" />

      </div>

      {/* 🔥 CAROUSEL */}
      <div className="carousel-wrapper">
        <motion.div
          className="carousel-track"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            repeat: Infinity,
            duration: 20, // speed (lower = faster)
            ease: 'linear',
          }}
        >
          {loopImages.map((img, i) => (
            <div className="carousel-item" key={i}>
              <img src={img.src} alt={img.label} />
              <div className="carousel-overlay">
                <span>{img.label}</span>
              </div>
            </div>
          ))}
        </motion.div>
      </div>

    </section>
  );
}